var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJustividePrimaryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #7474ff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M786.5,0H213.5C95.59,0,0,95.59,0,213.5v573.01c0,117.9,95.59,213.5,213.5,213.5h573.01c117.9,0,213.5-95.59,213.5-213.5V213.5C1000,95.59,904.41,0,786.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M604.62,335.59h96.17c3.5,0,6.35-2.86,6.35-6.35v-42.8c0-3.5-2.86-6.35-6.35-6.35h-269.6c-3.5,0-6.35,2.86-6.35,6.35v42.8c0,3.5,2.86,6.35,6.35,6.35h103.56l1.03,116.93v161.73c-.36,86.69-20.43,137.29-88.15,137.29s-87.75-50.61-88.51-136.2c0-3.25-2.19-5.11-5.47-5.11h-55.71c-3.25,0-5.11,1.82-5.11,5.11,1.46,119.48,47.33,190.12,154.41,190.12s156.99-65.93,156.63-190.85l-.36-162.07,1.03-116.93h.06l.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M431.19,194.53h269.6c3.5,0,6.32,2.86,6.32,6.32v42.8c0,3.5-2.86,6.35-6.35,6.35h-269.6c-3.5,0-6.35-2.86-6.35-6.35v-42.77c0-3.5,2.86-6.35,6.35-6.35h.03Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustividePrimaryIcon);
export default __webpack_public_path__ + "static/media/Justivide-PrimaryIcon.4f410357aa1693f41e16dffb2557f1ae.svg";
export { ForwardRef as ReactComponent };